// Delay (before starting animations)
export const DELAY = 50;

// Duration (for animations)
export const SHORT = 500;
export const DEFAULT_DURATION = 750;
export const LONG = 1500;

// Keyboard events and codes
export const ESCAPE = 27;
export const RETURN = 13;

// Position
export const BOTTOM = 'bottom';
export const LEFT = 'left';
export const RIGHT = 'right';
export const TOP = 'top';

// Sort
export const DESCENDING = 'descending';

// Miscellaneous events for analytics apps
export const CLICKED = 'clicked';
export const CLOSE = 'close';
export const COMPLETE = 'complete';
export const CUSTOM_PERIOD_REQUESTED = 'customPeriodRequested';
export const CUSTOM_PERIOD_SELECTED = 'customPeriodSelected';
export const CUSTOM_COMPARISON_REQUESTED = 'customComparisonRequested';
export const CUSTOM_COMPARISON_SELECTED = 'customComparisonSelected';
export const DATA_EXPORT_REQUESTED = 'dataExportRequested';
export const DRILL = 'drill';
export const EDIT = 'edit';
export const ERROR = 'error';
export const FACILITY_NOT_FOUND = 'facilityNotFound';
export const NO_VALID_BUILDINGS = 'noValidBuildings';
export const OPEN = 'open';
export const RENDERED = 'rendered';
export const RESET = 'reset';
export const RESIZE = 'resize';
export const SAVED = 'saved';
export const SELECTION_CHANGED = 'selectionChanged';
export const SELECTIONS_CHANGED = 'selectionsChanged';
export const SUCCESS = 'success';
